import ContentOverlay from "../components/content_overlay";
import {Link} from "react-router-dom";
import "./abstract.css";

function BibliographyPage(){
    return (
        <ContentOverlay
        heading={ <h3 style={{textAlign:"center"}}>Bibliography</h3> }
        text_content={<div><ol>
            <li>
            <p>Roy, D., Das, B., Singh, P., Santra, P., Deb, S., Bhattacharya, B. K., ... &amp; Chakraborty, D. (2025). Assessing the accuracy of multi-model approaches for downscaling land surface temperature across diverse agroclimatic zones.<em>Scientific Reports</em>,<em>15</em>(1), 10824.</p>
           
            <p></p></li></ol>
            <ol start="2">
            <li>
            <p>Jalota, S. K., &amp; Vashisht, B. B. (2016). Adapting cropping systems to future climate change scenario in three agro-climatic zones of Punjab, India.<em>Journal of Agrometeorology</em>,<em>18</em>(1), 48-56.</p>
           
            <p ></p></li></ol>
            <ol start="3">
            <li>
            <p>Aithal, B. H., &amp; MC, C. (2019). Assessing land surface temperature and land use change through spatio-temporal analysis: a case study of select major cities of India.<em>Arabian Journal of Geosciences</em>,<em>12</em>, 1-16.</p>
           
            <p ></p></li></ol>
            <ol start="4">
            <li>
            <p>Singh, N. P., Rao, B. A. S. S. K., &amp; Prabhakar, S. B. M. (2020). Assessing the impacts of climate change on crop yields in different agro-climatic zones of India.<em>Journal of Atmospheric Science Research| Volume</em>,<em>3</em>(04).</p>
           
            <p ></p></li></ol>
            <ol start="5">
            <li>
            <p>Roy, D., Das, B., Rathore, P., Santra, P., Deb, S., Bhattacharya, B. K., ... &amp; Chakraborty, D. (2024). Downscaling Land Surface Temperature at Farm-Scale Using Multi-Model Approaches over Diverse Agro Climatic Zones.</p>
           
            <p ></p></li></ol>
            <ol start="6">
            <li>
            <p>Roy, D., Das, B., Rathore, P., Santra, P., Deb, S., Bhattacharya, B. K., ... &amp; Chakraborty, D. (2024). Downscaling Land Surface Temperature at Farm-Scale Using Multi-Model Approaches over Diverse Agro Climatic Zones.</p>
           
            <p></p></li></ol>
            <ol start="7">
            <li>
            <p>Rani, S., Singh, S., &amp; Purohit, S. (2024). Evaluating Daytime and Nighttime Land Surface Temperature Pattern and Trends in India: A Comparative Analysis of Satellite and Reanalysis Data.<em>Earth Systems and Environment</em>, 1-22.</p>
           
            <p ></p></li></ol>
            <ol start="8">
            <li>
            <p>Mall, R. K., Chaturvedi, M., Singh, N., Bhatla, R., Singh, R. S., Gupta, A., &amp; Niyogi, D. (2021). Evidence of asymmetric change in diurnal temperature range in recent decades over different agro-climatic zones of India.<em>Int. J. Climatol</em>,<em>41</em>(4), 2597-2610.</p>
           
            <p ></p></li></ol>
            <ol start="9">
            <li>
            <p>Bapatla, K. G., Singh, A. D., Sengottaiyan, V., Korada, R. R., &amp; Yeddula, S. (2022). Impact of climate change on Helicoverpa armigera voltinism in different Agro-Climatic Zones of India.<em>Journal of Thermal Biology</em>,<em>106</em>, 103229.</p>
           
            <p ></p></li></ol>
            <ol start="10">
            <li>
            <p>Chattopadhyay, N., Sahai, A. K., Guhathakurta, P., Dutta, S., Srivastava, A. K., Attri, S. D., ... &amp; Chandras, S. (2019). Impact of observed climate change on the classification of agroclimatic zones in India.<em>Current Science</em>,<em>117</em>(3), 480-486.</p>
           
            <p ></p></li></ol>
            <ol start="11">
            <li>
            <p>Awasthi, A., Pattnayak, K. C., Tandon, A., Sarkar, A., &amp; Chakraborty, M. (2023). Implications of climate change on surface temperature in North Indian states: evidence from CMIP6 model ensembles.<em>Frontiers in Environmental Science</em>,<em>11</em>, 1264757.</p>
           
            <p ></p></li></ol>
            <ol start="12">
            <li>
            <p>Parida, B. R., Bar, S., Roberts, G., Mandal, S. P., Pandey, A. C., Kumar, M., &amp; Dash, J. (2021). Improvement in air quality and its impact on land surface temperature in major urban areas across India during the first lockdown of the pandemic.<em>Environmental research</em>,<em>199</em>, 111280.</p>
           
            <p ></p></li></ol>
            <ol start="13">
            <li>
            <p>Singh, R. N., Sah, S., Das, B., Jaiswal, R., Singh, A. K., Reddy, K. S., &amp; Pathak, H. (2024). Innovative and polygonal trend analysis of temperature in agro climatic zones of India.<em>Scientific Reports</em>,<em>14</em>(1), 1-20.</p>
           
            <p ></p></li></ol>
            <ol start="14">
            <li>
            <p>Paramesh, V., Kumar, P., Shamim, M., Ravisankar, N., Arunachalam, V., Nath, A. J., ... &amp; Kashyap, P. (2022). Integrated farming systems as an adaptation strategy to climate change: case studies from diverse agro-climatic zones of India.<em>Sustainability</em>,<em>14</em>(18), 11629.</p>
           
            <p ></p></li></ol>
            <ol start="15">
            <li>
            <p>Ramachandra, T. V., Srijith, A. H., &amp; Bharath, S. LAND SURFACE TEMPERATURE RESPONSES TO THE LAND COVER DYNAMICS IN WESTERN GHATS.</p>
           
            <p ></p></li></ol>
            <ol start="16">
            <li>
            <p>Prakash, S., &amp; Norouzi, H. (2020). Land surface temperature variability across India: a remote sensing satellite perspective.<em>Theoretical and Applied Climatology</em>,<em>139</em>, 773-784.</p>
           
            <p ></p></li></ol>
            <ol start="17">
            <li>
            <p>Singh, H. V., Joshi, N., &amp; Suryavanshi, S. (2023). Projected Climate Extremes over Agro-climatic Zones of Ganga River Basin under 1.5, 2 and 3-degree Global Warming Levels.</p>
           
            <p ></p></li></ol>
            <ol start="18">
            <li>
            <p>Nayak, S. (2021). Land use and land cover change and their impact on temperature over central India.<em>Letters in Spatial and Resource Sciences</em>,<em>14</em>(2), 129-140.</p>
           
            <p ></p></li></ol>
            <ol start="19">
            <li>
            <p>Singh, H. V., Joshi, N., &amp; Suryavanshi, S. (2023). Projected climate extremes over agro-climatic zones of Ganga River Basin under 1.5, 2, and 3&deg; global warming levels.<em>Environmental Monitoring and Assessment</em>,<em>195</em>(9), 1062.</p>
           
            <p ></p></li></ol>
            <ol start="20">
            <li>
            <p>Bhatla, R., Sarkar, D., Verma, S., Sinha, P., Ghosh, S., &amp; Mall, R. K. (2020). Regional climate model performance and application of bias corrections in simulating summer monsoon maximum temperature for agro-climatic zones in India.<em>Theoretical and Applied Climatology</em>,<em>142</em>, 1595-1612.</p>
           
            <p ></p></li></ol>
            <ol start="21">
            <li>
            <p>Choudhury, I. (2015). Seasonal and inter-annual variation in surface energy fluxes and forcing parameters in agro-climatic regions of India.<em>International Journal of Remote Sensing</em>,<em>36</em>(9), 2375-2394.</p>
           
            <p ></p></li></ol>
            <ol start="22">
            <li>
            <p>Sonkar, G., Singh, N., Mall, R. K., Singh, K. K., &amp; Gupta, A. (2020). Simulating the impacts of climate change on sugarcane in diverse Agro-climatic zones of northern India using CANEGRO-Sugarcane model.<em>Sugar Tech</em>,<em>22</em>, 460-472.</p>
           
            <p ></p></li></ol>
            <ol start="23">
            <li>
            <p>Ahmad, L., &amp; Kanth, R. H. (2018). Spatial and Temporal Land Surface Temperature Analysis of Kashmir Valley (India).<em>Indian Journal of Ecology</em>,<em>45</em>(3), 566-569.</p>
           
            <p ></p></li></ol>
            <ol start="24">
            <li>
            <p>Rao, P., Gupta, K., Roy, A., &amp; Balan, R. (2021). Spatio-temporal analysis of land surface temperature for identification of heat wave risk and vulnerability hotspots in Indo-Gangetic Plains of India.<em>Theoretical and Applied Climatology</em>,<em>146</em>(1), 567-582.</p>
           
            <p ></p></li></ol>
            <ol start="25">
            <li>
            <p>PAUL, R., PAUL, A., GURUNG, B., &amp; BIRTHAL, P. (2015). Temperature trend in different agro-climatic zones in India.<em>Mausam</em>,<em>66</em>(4), 841-846.</p>
           
            <p ></p></li></ol>
            <ol start="26">
            <li>
            <p>CSTEP. (2022). Climate atlas of India: District-level analysis of historical and projected climate change scenarios. (CSTEP-RR-2022-14).</p>
           
            <p ></p></li></ol>
            <ol start="27">
            <li>
            <p>Manohar Arora, N. K. Goel &amp; Pratap Singh (2005) Evaluation of temperature trends over India / Evaluation de tendances de temp&eacute;rature en Inde, <em>Hydrological Sciences Journal</em>, 50:1, -93, DOI: 10.1623/hysj.50.1.81.56330</p>
           
            <p ></p></li></ol>
            <ol start="28">
            <li>
            <p>Climate Risk Country Profile: India (2021): The World Bank Group.</p>
           
            <p ></p></li></ol>
            <ol start="29">
            <li>
            <p>Prayas, (2022, May). A review of Heat and Health research in India: Knowledge gaps in building climate change adaptation responses.</p>
           
            <p lang="en-IN"></p></li></ol></div>}
        />

    )
}
export default BibliographyPage;